import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { updateUserGoal } from '../lib/api';

export const useUpdateUserGoal = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (goalStatement: string) => {
      const token = await getToken();
      if (!token) {
        throw new Error('Authentication required');
      }
      return updateUserGoal(token, goalStatement);
    },
    onSuccess: () => {
      // Invalidate and refetch user profile data
      queryClient.invalidateQueries({ queryKey: ['current-user'] });
    },
    onError: (error) => {
      console.error('Failed to update user goal:', error);
    }
  });
};
